import { Component, Inject} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector   : 'promote-user-dialog',
    templateUrl: './promote-user-dialog.html'
})
export class PromoteUserDialogComponent
{

    constructor( public dialogRef: MatDialogRef<PromoteUserDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any)
    {
    }

    onNoClick(): void
    {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/promote/promote.user.dialog.component.ts